import { IApplicationState } from '../../types/redux';

export function getComparisonStatus({ newbuilding: { comparisonStatus } }: IApplicationState) {
  return comparisonStatus;
}
